import { render, staticRenderFns } from "./payrollSetting.vue?vue&type=template&id=26f88c62&scoped=true&"
import script from "./payrollSetting.vue?vue&type=script&lang=js&"
export * from "./payrollSetting.vue?vue&type=script&lang=js&"
import style0 from "./payrollSetting.vue?vue&type=style&index=0&id=26f88c62&scoped=true&lang=css&"
import style1 from "./payrollSetting.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f88c62",
  null
  
)

export default component.exports